import { BaseApiClient } from '../base-api-client';
export var AlertTier;
(function (AlertTier) {
    AlertTier[AlertTier["TIER_1"] = 1] = "TIER_1";
    AlertTier[AlertTier["TIER_2"] = 2] = "TIER_2";
    AlertTier[AlertTier["TIER_3"] = 3] = "TIER_3";
})(AlertTier || (AlertTier = {}));
export var AlertType;
(function (AlertType) {
    AlertType["LISTING"] = "listing";
    AlertType["DELISTING"] = "delisting";
})(AlertType || (AlertType = {}));
export class NewsSubscriptionClient extends BaseApiClient {
    constructor(config) {
        const fullConfig = {
            ...config,
            baseURL: `${config.baseURL}/news-subscriptions`,
        };
        super(fullConfig, 'NewsSubscriptionClient');
    }
    async healthCheck() {
        try {
            const response = await this.get('/health');
            return response.success;
        }
        catch (error) {
            console.error('[NewsSubscriptionClient] Health check failed:', this.truncateError(error));
            return false;
        }
    }
    async createNewsSubscription(userId) {
        try {
            const response = await this.post(`/${userId}`, {});
            if (!response.success) {
                throw new Error(response.error || 'Failed to create news subscription');
            }
        }
        catch (error) {
            console.error(`[NewsSubscriptionClient] Error creating news subscription for user ${userId}:`, this.truncateError(error));
            throw error;
        }
    }
    async deleteNewsSubscription(userId) {
        try {
            const response = await this.delete(`/${userId}`);
            if (!response.success) {
                throw new Error(response.error || 'Failed to delete news subscription');
            }
        }
        catch (error) {
            console.error(`[NewsSubscriptionClient] Error deleting news subscription for user ${userId}:`, this.truncateError(error));
            throw error;
        }
    }
    async getNewsSubscriptionByUserId(userId) {
        try {
            const response = await this.get(`/${userId}`);
            if (!response.success) {
                throw new Error(response.error || 'Failed to get news subscription');
            }
            return response.data || null;
        }
        catch (error) {
            console.error(`[NewsSubscriptionClient] Error getting news subscription for user ${userId}:`, this.truncateError(error));
            throw error;
        }
    }
    async updateListingNewsPreference(userId, receive) {
        try {
            const response = await this.put(`/${userId}/preferences/listing`, { receive });
            if (!response.success) {
                throw new Error(response.error || 'Failed to update listing news preference');
            }
        }
        catch (error) {
            console.error(`[NewsSubscriptionClient] Error updating listing news preference for user ${userId}:`, this.truncateError(error));
            throw error;
        }
    }
    async updateDelistingNewsPreference(userId, receive) {
        try {
            const response = await this.put(`/${userId}/preferences/delisting`, { receive });
            if (!response.success) {
                throw new Error(response.error || 'Failed to update delisting news preference');
            }
        }
        catch (error) {
            console.error(`[NewsSubscriptionClient] Error updating delisting news preference for user ${userId}:`, this.truncateError(error));
            throw error;
        }
    }
    async updateTierNotificationPreference(userId, alertType, tier, enabled) {
        try {
            const response = await this.put(`/${userId}/preferences/tier`, {
                alertType,
                tier,
                enabled,
            });
            if (!response.success) {
                throw new Error(response.error || 'Failed to update tier notification preference');
            }
        }
        catch (error) {
            console.error(`[NewsSubscriptionClient] Error updating tier notification preference for ${userId}:`, this.truncateError(error));
            throw error;
        }
    }
}
//# sourceMappingURL=news-subscription-client.js.map